let get_refresh_grid = function() {
	if (this.get_refresh_grid) {
		this.starGrid();
		this.$store.commit("ModApps/jobs/set_refresh_grid", false);
	}
};
export default get_refresh_grid;
